var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningNotifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66675C14.6028 1.66675 18.3337 5.39758 18.3337 10.0001C18.3337 14.6026 14.6028 18.3334 10.0003 18.3334C5.39783 18.3334 1.66699 14.6026 1.66699 10.0001C1.66699 5.39758 5.39783 1.66675 10.0003 1.66675ZM10.0003 12.5001C9.77931 12.5001 9.56735 12.5879 9.41107 12.7442C9.25479 12.9004 9.16699 13.1124 9.16699 13.3334C9.16699 13.5544 9.25479 13.7664 9.41107 13.9227C9.56735 14.079 9.77931 14.1667 10.0003 14.1667C10.2213 14.1667 10.4333 14.079 10.5896 13.9227C10.7459 13.7664 10.8337 13.5544 10.8337 13.3334C10.8337 13.1124 10.7459 12.9004 10.5896 12.7442C10.4333 12.5879 10.2213 12.5001 10.0003 12.5001ZM10.0003 5.00008C9.79621 5.00011 9.59921 5.07504 9.44668 5.21068C9.29415 5.34631 9.19671 5.53321 9.17283 5.73591L9.16699 5.83341V10.8334C9.16723 11.0458 9.24856 11.2501 9.39437 11.4046C9.54017 11.559 9.73945 11.6519 9.95149 11.6644C10.1635 11.6768 10.3723 11.6079 10.5352 11.4715C10.6981 11.3352 10.8027 11.1418 10.8278 10.9309L10.8337 10.8334V5.83341C10.8337 5.6124 10.7459 5.40044 10.5896 5.24416C10.4333 5.08788 10.2213 5.00008 10.0003 5.00008Z",
    fill: "#F1A33A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningNotifIcon);
export default __webpack_public_path__ + "static/media/warning-notif-icon.920cc991a4897278ac34e6d7727d3a47.svg";
export { ForwardRef as ReactComponent };